import React from 'react';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {  Row, Col } from 'react-bootstrap';
import moment from 'moment';
import flattenDeep from 'lodash/flattenDeep';
import uniq from 'lodash/uniq';

import WeekPicker from '../common/DatePicker/WeekPicker';


class AssignmentList extends React.Component {
  constructor(props) {
    super(props);

    this.handleCourseSearch = this.handleCourseSearch.bind(this)


    this.state = {
      filteredDays: null,
      searchTerm: null
    }
  }

  getDateInRange = (startDate, endDate) => {
    const { filteredDays } = this.state;
    if (!filteredDays) {
      return true;
    }
  
    const startDay = moment(filteredDays[0]); // initial date of the range
    const endDay = moment(filteredDays[filteredDays.length - 1]);
    const startDateMoment = moment(startDate); // initial day of the course
    const endDateMoment = moment(endDate); // end day of the course
  
    const inRange = startDay // checks if the start day of the picked week is between the start date and end date of the meeting
      .isBetween(startDateMoment, endDateMoment, null, '[]') ||
      endDay // checks if the end day of the picked week is between the start date and end date of the meeting
        .isBetween(startDateMoment, endDateMoment, null, '[]');
  
    return inRange;
  }

  parseItems = (items = [], courses = []) => {
    if (courses.length === 0) return [];

    // I'm sorry this isn't my fault, but map -> filter -> reduce -> filter
    // should be rewritten
    const parsedItems = items.map(item => {
      const course = courses.filter(course => course.id === item.course)[0] || {};
      const inRange = course && course.meetings.reduce((prev, curr) => {
        const { enddate, startdate } = curr;
        const classInRange = this.getDateInRange(startdate, enddate);

        return prev && classInRange;
      }, true);
      return {
        inRange,
        ...item,
        ...course
      };
    }).filter(item => {
      if (this.state.searchTerm) {
        return item.slug.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) != -1 ||
          item.longname.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) != -1 ||
          item.instructor.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) != -1
      }
      return true
    })

    return  parsedItems.filter((i) => i.inRange);
  };

  getCreditCount = (courses = []) => {
    const creditCount = courses.reduce((prev, curr) => prev + curr.weight, 0);

    return creditCount;
  }

  getMinMaxDateFromCourses = (items, courses) => {
    // Map courses to assignments and return the meetings
    const mappedCoursesToAssignments = items.map((a) => {
      const matchedCourse = courses.find((c) => c.id === a.course);

      if (matchedCourse) {
        return { ...a, meetings: matchedCourse.meetings }
      }

      return a;
    })

    // reduce meetings to a flat array of meetings
    const meetingCourses = mappedCoursesToAssignments.reduce((prev, curr) => {
      const meetings = curr.meetings
        ? curr.meetings.map((m) => ([m.startdate, m.enddate]))
        : []

      return [...prev, ...flattenDeep(meetings)];
    }, []);

    const uniqueMeetings = uniq(meetingCourses);

    uniqueMeetings.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

    return {
      minDate: uniqueMeetings[0],
      maxDate: uniqueMeetings[uniqueMeetings.length - 1]
    }
  }

  handleSelectWeek = (weekDays) => {
    this.setState({ filteredDays: weekDays });
  }

  handleCourseSearch(e) {
    e.preventDefault();
    let searchTerm = e.target.value;
    this.setState({
      searchTerm: searchTerm.length ? searchTerm : null
    })
  }

  render() {
    const { isLoading, items = [], courses = [], runSlug } = this.props;
    const parsedItems = this.parseItems(items, courses);
    const creditCount = this.getCreditCount(parsedItems);
    const { minDate, maxDate } = this.getMinMaxDateFromCourses(items, courses);

    const formatName = (courseSlug, course) => (
      <Link
        className="linkToClass"
        to={`/administer/${runSlug}/class/${course.id}`}
      >
        {courseSlug}
      </Link>
    );
    const renderPassFail = passFail => <span>{passFail ? 'Pass/Fail' : 'Letter'}</span>
    if (isLoading)
      return (
        <div >
          <div className="page-subtitle">Schedule ({creditCount} Credits)</div>
          <Spinner spinnerName="three-bounce" />
        </div>
      );
    if (items.length === 0)
      return (
        <div>
          <div className="page-subtitle">Schedule ({creditCount} Credits)</div>
          <p>No assignments</p>
        </div>
      );
    return (
      <div>
        <div className="page-subtitle clearfix">
          <Row>
            <Col md={12}>
              <span>Schedule ({creditCount} Credits)</span>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md={9}>
            <div className="form-group search">
              <span className="fa fa-search" />
              <input
                name="conflictSearchInput"
                onChange={this.handleCourseSearch}
                type="text"
                className="form-control search"
                placeholder="Type name, description or instructor to filter courses"
              />
            </div>
          </Col>
          <Col md={3}>
            <WeekPicker
              handleSelectWeek={this.handleSelectWeek}
              minDate={minDate}
              maxDate={maxDate}
              inputClassNames="week-picker-auto-width"
            />
          </Col>
        </Row>
        <BootstrapTable
          data={parsedItems}
          bordered={false}
          hover={true}
          condensed={true}
        >
          <TableHeaderColumn
            dataField="slug"
            isKey={true}
            dataSort={true}
            dataFormat={formatName}
            width="10%"
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="longname" width="40%" dataSort={true}>
            Description
          </TableHeaderColumn>
          <TableHeaderColumn dataField="instructor" width="20%" dataSort={true}>
            Instructor
          </TableHeaderColumn>
          <TableHeaderColumn dataField="pass_fail" width="10%" dataFormat={renderPassFail}>
            Grading
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="weight"
            dataAlign="center"
            dataSort={true}
            width="10%"
          >
            Credits
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default AssignmentList;



// WEBPACK FOOTER //
// ./src/components/students/AssignmentList.js